/**
 * Swoop Next kit — header, PDP, upsell modal, cart recap at all widths.
 */
(function () {
  'use strict';

  function kitIsNext() {
    return document.documentElement.getAttribute('data-storefront-kit') === 'next';
  }

  function active() {
    return kitIsNext();
  }

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }

  function $$(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function money(cents) {
    if (window.SwoopMoney && typeof SwoopMoney.format === 'function') {
      return SwoopMoney.format(cents);
    }
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  function family(name) {
    if (window.SwoopColor && typeof SwoopColor.family === 'function') {
      return SwoopColor.family(name) || 'teal';
    }
    var c = String(name || '').toLowerCase();
    if (/pink|rose|poupette|magenta|fuchsia/.test(c)) return 'pink';
    return 'teal';
  }

  function setTheme(name) {
    var fam = family(name);
    if (fam !== 'pink' && fam !== 'teal') fam = 'teal';
    if (document.documentElement.getAttribute('data-snx-theme') === fam) return;
    document.documentElement.setAttribute('data-snx-theme', fam);
  }

  function applyThemeFromQtys(tealQty, pinkQty) {
    if (Number(pinkQty) > 0 && Number(tealQty) === 0) setTheme('pink');
    else setTheme('teal');
    try {
      localStorage.setItem('snx-teal-qty', String(tealQty || 0));
      localStorage.setItem('snx-pink-qty', String(pinkQty || 0));
    } catch (err) {}
  }

  function rememberPdpColor(name) {
    if (!name) return;
    try { localStorage.setItem('snx-pdp-color', name); } catch (err) {}
  }

  function storedPdpColor() {
    try { return localStorage.getItem('snx-pdp-color') || ''; } catch (err) { return ''; }
  }

  function brandSwoop(title) {
    var t = String(title || '');
    if (!t) return t;
    return t.replace(/\bSwoop(?!\s*®)/, 'Swoop®');
  }

  function catcherDisplayName() {
    var root = $('[data-snx-cart]');
    var named = root && root.getAttribute('data-catcher-name');
    if (named) return named;
    var lang = document.documentElement.lang || '';
    if (/^fr\b/i.test(lang)) return 'Le Swoop';
    if (/^de\b/i.test(lang)) return 'Le Swoop';
    return 'Catcher';
  }

  function displayItemTitle(item) {
    var title = (item && (item.product_title || item.title)) || '';
    if (item && isCatcherItem(item)) {
      var name = catcherDisplayName();
      if (name && !/^catcher$/i.test(name)) return name;
    }
    return brandSwoop(title);
  }

  function paintProgressText(el, tpl, remain) {
    if (!el) return;
    var html = escapeHtml(String(tpl || '')).replace(/\{amount\}/g, '<span class="snx-accent">' + escapeHtml(remain) + '</span>');
    html = html.replace(/FREE SHI\*TTING/gi, '<span class="snx-accent">$&</span>');
    el.innerHTML = html;
  }

  function lockScrollTarget(node) {
    while (node && node !== document.body && node !== document.documentElement) {
      if (node.nodeType === 1 && node.closest) {
        if (node.closest('.snx-nav, .snx-sheet__scroll, .snx-sheet')) return true;
      }
      node = node.parentNode;
    }
    return false;
  }

  function onLockTouchMove(e) {
    if (lockScrollTarget(e.target)) return;
    e.preventDefault();
  }

  function lock(on) {
    var html = document.documentElement;

    if (on) {
      html.classList.add('snx-lock');
      if (html.getAttribute('data-snx-scroll-locked') === '1') return;
      html.setAttribute('data-snx-scroll-locked', '1');
      document.addEventListener('touchmove', onLockTouchMove, { passive: false });
      return;
    }

    html.classList.remove('scd-lock');
    if (html.getAttribute('data-snx-scroll-locked') !== '1') {
      html.classList.remove('snx-lock');
      return;
    }
    html.removeAttribute('data-snx-scroll-locked');
    document.removeEventListener('touchmove', onLockTouchMove, { passive: false });
    html.classList.remove('snx-lock');
  }

  function routes() {
    var root = $('[data-snx-cart]');
    return {
      cart: (root && root.getAttribute('data-cart-url')) || '/cart.js',
      add: (root && root.getAttribute('data-add-url')) || '/cart/add.js',
      change: (root && root.getAttribute('data-change-url')) || '/cart/change.js',
      checkout: '/checkout'
    };
  }

  function checkoutUrl() {
    var host = window.location.hostname;
    var local = host === '127.0.0.1' || host === 'localhost';
    return local ? '/checkout?skip_shop_pay=true' : '/checkout';
  }

  var cartState = null;

  function ajaxUrl(url) {
    var base = String(url || '').split('?')[0];
    return /\.js$/.test(base) ? base : base + '.js';
  }

  function getCart() {
    return fetch(ajaxUrl(routes().cart), {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (r) { return r.json(); });
  }

  function addItem(payload) {
    return fetch(ajaxUrl(routes().add), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json(); });
  }

  function changeItem(key, quantity) {
    return fetch(ajaxUrl(routes().change), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }

  function syncBadges(cart) {
    var count = cart && cart.item_count ? cart.item_count : 0;
    $$('[data-cart-count-badge], [data-snx-cart-count]').forEach(function (el) {
      el.hidden = count === 0;
      el.textContent = count > 0 ? String(count) : '';
    });
  }

  function replaceTpl(tpl, map) {
    return String(tpl || '').replace(/\{(\w+)\}/g, function (_, k) {
      return map[k] != null ? map[k] : '';
    });
  }

  function decodeEntities(value) {
    var raw = String(value || '');
    if (!raw || raw.indexOf('&') === -1) return raw;
    var box = document.createElement('textarea');
    box.innerHTML = raw;
    return box.value;
  }

  function cartTotal(cart) {
    if (!cart) return 0;
    if (cart.items_subtotal_price != null) return Number(cart.items_subtotal_price) || 0;
    return Number(cart.total_price) || 0;
  }

  function rewardThresholds(root) {
    return [
      Number(root.getAttribute('data-reward-1') || 69) * 100,
      Number(root.getAttribute('data-reward-2') || 108) * 100
    ].filter(function (n) { return n > 0; });
  }

  function rewardStopPct(lineEl, stopEl, edge) {
    if (!lineEl || !stopEl) return 0;
    var lineBox = lineEl.getBoundingClientRect();
    var icon = $('.snx-rewards__icon', stopEl) || stopEl;
    var iconBox = icon.getBoundingClientRect();
    if (!lineBox.width) return 0;
    var x = edge === 'right' ? iconBox.right : iconBox.left;
    return Math.max(0, Math.min(100, ((x - lineBox.left) / lineBox.width) * 100));
  }

  function rewardFillWidth(scope, phase, total, shipAt, giftAt) {
    var fillEl = $('[data-snx-reward-fill]', scope);
    var lineEl = fillEl && fillEl.parentElement;
    var shipEl = $('[data-snx-reward="ship"]', scope);
    var giftEl = $('[data-snx-reward="gift"]', scope);
    var beforeShip = rewardStopPct(lineEl, shipEl, 'left') || 42;
    var afterShip = rewardStopPct(lineEl, shipEl, 'right') || 50;
    var beforeGift = rewardStopPct(lineEl, giftEl, 'left') || 92;
    if (phase === 'ship') {
      return shipAt ? beforeShip * (total / shipAt) : 0;
    }
    if (phase === 'gift') {
      if (total < shipAt) return afterShip;
      var span = Math.max(beforeGift - afterShip, 1);
      return afterShip + span * ((total - shipAt) / Math.max(giftAt - shipAt, 1));
    }
    return 100;
  }

  function renderRewards(scope, cart) {
    var root = $('[data-snx-cart]');
    if (!root || !scope) return;
    var block = $('[data-snx-rewards]', scope);
    var empty = !cart || !cart.item_count;
    if (block) block.hidden = empty;
    if (empty) return;
    var total = cartTotal(cart);
    var stops = rewardThresholds(root);
    var shipAt = stops[0] || 0;
    var giftAt = stops[1] || 0;
    var shipFree = shippingUnlocked(cart);
    var shipReached = !!(shipAt && (total >= shipAt || shipFree));
    var phase = giftAt && total >= giftAt ? 'done' : shipReached ? 'gift' : 'ship';
    if (block) {
      block.setAttribute('data-phase', phase);
      block.classList.toggle('is-complete', phase === 'done');
    }
    $$('[data-snx-reward-stop]', scope).forEach(function (el, i) {
      var reached = (shipFree && i === 0) || total >= (stops[i] || 0);
      el.classList.toggle('is-done', reached);
      el.hidden = false;
      var lab = $('[data-snx-reward-label]', el);
      if (lab && stops[i]) lab.textContent = money(stops[i]);
    });
    var line = $('[data-snx-reward-fill]', scope);
    function paintFill() {
      var fill = Math.max(0, Math.min(100, rewardFillWidth(scope, phase, total, shipAt, giftAt)));
      if (line) {
        line.style.width = fill + '%';
        line.setAttribute('data-progress', String(Math.round(fill)));
      }
    }
    paintFill();
    if (line && !line.parentElement.getBoundingClientRect().width) {
      requestAnimationFrame(paintFill);
    }
    var copy = $('[data-snx-reward-copy]', scope);
    if (!copy) return;
    var next = stops.find(function (n, i) {
      if (shipFree && i === 0) return false;
      return total < n;
    });
    if (!next) {
      copy.innerHTML = '';
      copy.textContent = root.getAttribute('data-reward-done') || '';
      return;
    }
    var remain = money(next - total);
    var giftTpl = root.getAttribute('data-reward-gift') || '';
    var shipTpl = root.getAttribute('data-shipping-progress') || '';
    paintProgressText(copy, next === stops[0] ? shipTpl : giftTpl, remain);
  }

  function renderFooter(scope, cart) {
    var countEl = $('[data-snx-subtotal-count]', scope);
    var priceEl = $('[data-snx-subtotal-price]', scope);
    var count = cart && cart.item_count ? cart.item_count : 0;
    var total = cartTotal(cart);
    if (countEl) countEl.textContent = String(count);
    if (priceEl) priceEl.textContent = money(total);
  }

  function renderItems(cart) {
    var list = $('[data-snx-items]');
    var empty = $('[data-snx-empty]');
    if (!list) return;
    var cartRoot = $('[data-snx-cart]');
    var qtyDec = (cartRoot && cartRoot.getAttribute('data-qty-decrease')) || 'Decrease';
    var qtyInc = (cartRoot && cartRoot.getAttribute('data-qty-increase')) || 'Increase';
    var removeLabel = (cartRoot && cartRoot.getAttribute('data-remove-label')) || 'Remove';
    var items = (cart && cart.items) || [];
    if (!items.length) {
      list.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    list.innerHTML = items.map(function (it) {
      var img = it.image || '';
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
      var title = escapeHtml(displayItemTitle(it));
      if (variant) title += ' – ' + escapeHtml(variant);
      var plan = it.selling_plan_allocation && it.selling_plan_allocation.selling_plan;
      var showPlan = !cartRoot || cartRoot.getAttribute('data-item-plan-visibility') !== 'hide';
      var planName = showPlan && plan && plan.name ? '<p class="snx-item__plan">' + escapeHtml(plan.name) + '</p>' : '';
      return (
        '<article class="snx-item" data-snx-item data-key="' + it.key + '">' +
          (img ? '<img src="' + img + '" alt="" width="88" height="88">' : '<div class="snx-item__ph"></div>') +
          '<div class="snx-item__main">' +
            '<div class="snx-item__top">' +
              '<div class="snx-item__copy">' +
                '<p class="snx-item__title">' + title + '</p>' +
                planName +
              '</div>' +
              '<div class="snx-item__price">' + money(it.final_line_price) + '</div>' +
            '</div>' +
            '<div class="snx-item__controls">' +
              '<div class="snx-item__qty">' +
                '<button type="button" class="snx-item__qty-btn" data-snx-qty="-1" aria-label="' + escapeHtml(qtyDec) + '">−</button>' +
                '<span class="snx-item__qty-num">' + it.quantity + '</span>' +
                '<button type="button" class="snx-item__qty-btn" data-snx-qty="1" aria-label="' + escapeHtml(qtyInc) + '">+</button>' +
              '</div>' +
              '<button type="button" class="snx-item__remove" data-snx-remove aria-label="' + escapeHtml(removeLabel) + '">' +
                '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4h6v2"/></svg>' +
              '</button>' +
            '</div>' +
          '</div>' +
        '</article>'
      );
    }).join('');
  }

  function shipThreshold(root) {
    return Number(root.getAttribute('data-reward-1') || root.getAttribute('data-shipping-threshold') || 69) * 100;
  }

  var shipRates = { key: '', free: false, ready: false, inflight: '', req: 0 };

  function cartShipKey(cart) {
    return ((cart && cart.items) || []).map(function (it) {
      var plan = it.selling_plan_allocation && it.selling_plan_allocation.selling_plan;
      return String(it.variant_id) + ':' + it.quantity + ':' + (plan && plan.id ? plan.id : '');
    }).join('|');
  }

  function isFreeShipDiscount(app) {
    if (!app || app.applicable === false) return false;
    var target = String(app.target_type || '').toLowerCase();
    var title = String(app.title || app.code || '').toLowerCase();
    var named = /free\s*ship|livraison\s*gratuite|versandkostenfrei|kostenloser\s*versand|gratis\s*versand/.test(title);
    if (target === 'line_item') return false;
    if (target === 'shipping_line') {
      if (named) return true;
      return String(app.value_type || '').toLowerCase() === 'percentage' && parseFloat(app.value) >= 100;
    }
    return named;
  }

  function cartHasFreeShipDiscount(cart) {
    if (!cart) return false;
    var apps = []
      .concat(cart.cart_level_discount_applications || [])
      .concat(cart.discount_applications || [])
      .concat(cart.discount_codes || []);
    (cart.items || []).forEach(function (it) {
      (it.discounts || []).forEach(function (d) { apps.push(d); });
      (it.line_level_discount_allocations || []).forEach(function (alloc) {
        apps.push(alloc && alloc.discount_application ? alloc.discount_application : alloc);
      });
    });
    return apps.some(isFreeShipDiscount);
  }

  function shipAddressQuery() {
    var country = (window.Shopify && Shopify.country) || 'US';
    var presets = {
      US: 'shipping_address[zip]=10001&shipping_address[country]=United%20States&shipping_address[province]=NY',
      CA: 'shipping_address[zip]=K1A0A6&shipping_address[country]=Canada&shipping_address[province]=ON',
      GB: 'shipping_address[zip]=SW1A1AA&shipping_address[country]=United%20Kingdom',
      FR: 'shipping_address[zip]=75001&shipping_address[country]=France',
      DE: 'shipping_address[zip]=10115&shipping_address[country]=Germany'
    };
    return presets[country] || ('shipping_address[country]=' + encodeURIComponent(country));
  }

  function cartApi(path) {
    var base = (routes().cart || '/cart').split('?')[0].replace(/\.js$/, '').replace(/\/$/, '');
    return base + '/' + path;
  }

  function ratesIncludeFree(payload) {
    var rates = payload && payload.shipping_rates;
    if (!rates || !rates.length) return false;
    return rates.some(function (rate) { return Number(rate.price) === 0; });
  }

  function pollShipRates(query, attempt) {
    return fetch(cartApi('async_shipping_rates.json') + '?' + query, {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (r) { return r.text(); }).then(function (text) {
      if (!text || text === 'null') {
        if (attempt >= 7) return false;
        return new Promise(function (resolve) {
          setTimeout(function () { resolve(pollShipRates(query, attempt + 1)); }, 350);
        });
      }
      try { return ratesIncludeFree(JSON.parse(text)); }
      catch (err) { return false; }
    });
  }

  function paintShipSurfaces() {
    if (!cartState) return;
    renderShipRow(cartState);
    $$('[data-snx-sheet]').forEach(function (sheet) { renderRewards(sheet, cartState); });
    paintConfirm(cartState);
  }

  function ensureShipRates(cart) {
    var key = cartShipKey(cart);
    if (!key || (shipRates.ready && shipRates.key === key) || shipRates.inflight === key) return;
    var req = ++shipRates.req;
    shipRates.inflight = key;
    var query = shipAddressQuery();
    fetch(cartApi('prepare_shipping_rates.json') + '?' + query, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function () {
      return pollShipRates(query, 0);
    }).then(function (free) {
      if (req !== shipRates.req) return;
      shipRates.key = key;
      shipRates.free = !!free;
      shipRates.ready = true;
      shipRates.inflight = '';
      if (cartState && cartShipKey(cartState) === key) paintShipSurfaces();
    }).catch(function () {
      if (req !== shipRates.req) return;
      shipRates.key = key;
      shipRates.free = false;
      shipRates.ready = true;
      shipRates.inflight = '';
    });
  }

  function shippingUnlocked(cart) {
    var root = $('[data-snx-cart]');
    if (!cart || !cart.item_count || !root) return false;
    var shipAt = shipThreshold(root);
    if (shipAt && cartTotal(cart) >= shipAt) return true;
    if (cartHasFreeShipDiscount(cart)) return true;
    var key = cartShipKey(cart);
    if (shipRates.ready && shipRates.key === key) return shipRates.free;
    ensureShipRates(cart);
    return false;
  }

  function renderShipRow(cart) {
    var recap = $('[data-snx-sheet="recap"]');
    var row = recap && $('[data-snx-ship-row]', recap);
    var root = $('[data-snx-cart]');
    if (!row || !root) return;
    var hasItems = !!(cart && cart.item_count);
    row.hidden = !hasItems;
    if (!hasItems) return;
    var value = $('[data-snx-ship-value]', row);
    if (!value) return;
    var shipAt = shipThreshold(root);
    var unlocked = shippingUnlocked(cart);
    row.classList.toggle('is-free', unlocked);
    if (unlocked) {
      var badge = decodeEntities(root.getAttribute('data-shipping-free-badge') || 'FREE');
      value.innerHTML = '<span class="snx-ship-row__badge">' + escapeHtml(badge) + '</span>';
      return;
    }
    var tpl = decodeEntities(root.getAttribute('data-shipping-free-from') || 'Free from {amount}');
    value.textContent = replaceTpl(tpl, { amount: money(shipAt) });
  }

  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  var bagsProductCache;
  function bagsProduct() {
    if (bagsProductCache !== undefined) return bagsProductCache;
    var el = $('[data-snx-bags-product]');
    if (!el) {
      bagsProductCache = null;
      return null;
    }
    try {
      bagsProductCache = JSON.parse(el.textContent);
    } catch (err) {
      bagsProductCache = null;
    }
    return bagsProductCache;
  }

  var catcherProductCache;
  function catcherProduct() {
    if (catcherProductCache !== undefined) return catcherProductCache;
    var el = $('[data-snx-catcher-product]');
    if (!el) {
      catcherProductCache = null;
      return null;
    }
    try {
      catcherProductCache = JSON.parse(el.textContent);
    } catch (err) {
      catcherProductCache = null;
    }
    return catcherProductCache;
  }

  function cartHasBags(cart) {
    var product = bagsProduct();
    return ((cart && cart.items) || []).some(function (it) { return isBagsItem(it, product); });
  }

  function cartHasCatcher(cart) {
    return ((cart && cart.items) || []).some(function (it) { return isCatcherItem(it); });
  }

  function sizeMatch(a, b) {
    var na = parseInt(a, 10);
    var nb = parseInt(b, 10);
    if (!isNaN(na) && !isNaN(nb)) return na === nb;
    return String(a || '').toLowerCase() === String(b || '').toLowerCase();
  }

  function bagsAttr(name) {
    var pdp = $('[data-snx-pdp]');
    var root = $('[data-snx-cart]');
    return (pdp && pdp.getAttribute(name)) || (root && root.getAttribute(name)) || '';
  }

  function bagsPurchaseChoice() {
    return bagsAttr('data-bags-purchase-choice') || 'locked';
  }

  function bagsSellingModeDefault() {
    return bagsAttr('data-bags-selling-mode') || 'one_time';
  }

  function bagsPdpOffer() {
    var pdp = $('[data-snx-pdp][data-bags-mode="true"]');
    return (pdp && pdp.getAttribute('data-bags-offer')) || '';
  }

  function cartBagsAreSubscribed(cart) {
    var items = ((cart || cartState || {}).items) || [];
    var bags = items.filter(function (it) { return isBagsItem(it); });
    if (!bags.length) return null;
    return bags.some(function (it) { return !!(it.selling_plan_allocation || it.selling_plan); });
  }

  function bagsLockedOrDefaultSubscribe() {
    return bagsSellingModeDefault() === 'subscription';
  }

  function bagsPdpSubscribeActive() {
    if (bagsPurchaseChoice() === 'shopper_choice') {
      var offer = bagsPdpOffer();
      if (offer === 'subscription' || offer === 'one_time') return offer === 'subscription';
    }
    return bagsLockedOrDefaultSubscribe();
  }

  function bagsCartSubscribeActive() {
    if (bagsPurchaseChoice() === 'shopper_choice') {
      var offer = bagsAttr('data-bags-offer');
      if (offer === 'subscription' || offer === 'one_time') return offer === 'subscription';
      var inCart = cartBagsAreSubscribed();
      if (inCart !== null) return inCart;
    }
    return bagsLockedOrDefaultSubscribe();
  }

  function packSizeKey(size) {
    var n = parseInt(size, 10);
    if (n === 90 || n === 180) return String(n);
    var s = String(size || '').toLowerCase();
    if (s.indexOf('90') !== -1) return '90';
    if (s.indexOf('180') !== -1) return '180';
    return '';
  }

  function planText(plan) {
    var parts = [plan && plan.name];
    var opts = (plan && plan.options) || [];
    var i;
    for (i = 0; i < opts.length; i++) {
      if (typeof opts[i] === 'string') parts.push(opts[i]);
      else if (opts[i] && opts[i].value) parts.push(opts[i].value);
    }
    return parts.join(' ').toLowerCase();
  }

  function planTokensForSize(sizeKey) {
    if (sizeKey === '90') {
      return {
        prefer: [/4[\s-]*week/, /4[\s-]*semaine/, /4[\s-]*woche/, /4[\s-]*wochen/],
        avoid: [/3[\s-]*month/, /3[\s-]*mois/, /3[\s-]*monat/, /12[\s-]*week/, /6[\s-]*month/, /5[\s-]*week/]
      };
    }
    if (sizeKey === '180') {
      return {
        prefer: [/3[\s-]*month/, /3[\s-]*mois/, /3[\s-]*monat/, /12[\s-]*week/, /12[\s-]*semaine/],
        avoid: [/4[\s-]*week/, /5[\s-]*week/, /6[\s-]*month/, /12[\s-]*month/]
      };
    }
    return { prefer: [], avoid: [] };
  }

  function bagsPlanOverrides() {
    return {
      '90': String(bagsAttr('data-bags-sub-plan-90') || '').trim(),
      '180': String(bagsAttr('data-bags-sub-plan-180') || '').trim()
    };
  }

  function matchBagPlan(plans, size) {
    var sizeKey = packSizeKey(size);
    var list = plans || [];
    if (!list.length) return null;
    var override = bagsPlanOverrides()[sizeKey];
    if (override) {
      var forced = list.filter(function (p) { return String(p.id) === String(override); })[0];
      if (forced) return forced;
    }
    var tokens = planTokensForSize(sizeKey);
    var scored = list.map(function (plan) {
      var text = planText(plan);
      var score = 0;
      tokens.prefer.forEach(function (re) { if (re.test(text)) score += 100; });
      tokens.avoid.forEach(function (re) { if (re.test(text)) score -= 80; });
      if (/off for 1|1 order|first order|intro/.test(text)) score -= 15;
      return { plan: plan, score: score };
    }).sort(function (a, b) { return b.score - a.score; });
    if (scored[0] && scored[0].score > 0) return scored[0].plan;
    if (list.length === 1) return list[0];
    return null;
  }

  function bagOfferByVariantId(variantId) {
    var map = bagOfferMap();
    var id = String(variantId || '');
    var key;
    for (key in map) {
      if (!Object.prototype.hasOwnProperty.call(map, key)) continue;
      if (String(map[key] && map[key].id) === id) return map[key];
    }
    return null;
  }

  function plansForBagVariant(variant) {
    if (variant && variant.selling_plans && variant.selling_plans.length) return variant.selling_plans;
    var row = bagOfferByVariantId(variant && variant.id);
    if (row && row.selling_plans && row.selling_plans.length) return row.selling_plans;
    var allocs = variant && variant.selling_plan_allocations;
    if (allocs && allocs.length) {
      return allocs.map(function (a) {
        var plan = a.selling_plan || {};
        var opts = plan.options || [];
        return {
          id: a.selling_plan_id || plan.id,
          name: plan.name || '',
          price: a.price,
          options: opts.map(function (o) {
            return typeof o === 'string' ? o : (o && o.value) || '';
          })
        };
      });
    }
    return [];
  }

  function matchedBagPlan(variant, size) {
    return matchBagPlan(plansForBagVariant(variant), size || (variant && variant.size));
  }

  function bagUnitPrice(variant, size, subscribe) {
    if (subscribe) {
      var plan = matchedBagPlan(variant, size);
      if (plan && plan.price != null) return Number(plan.price);
    }
    return Number((variant && variant.price) || 0);
  }

  function bagSellingPlanId(variant, size, subscribe) {
    if (!subscribe) return 0;
    var plan = matchedBagPlan(variant, size);
    return plan ? Number(plan.id) : 0;
  }

  function bagsSubErrorText() {
    return bagsAttr('data-bags-sub-error') || 'Subscription isn’t available for this pack yet.';
  }

  function showBagsError(message) {
    var el = $('[data-snx-bags-error]');
    if (!el) return;
    el.textContent = message || bagsSubErrorText();
    el.hidden = false;
  }

  function hideBagsError() {
    var el = $('[data-snx-bags-error]');
    if (el) el.hidden = true;
  }

  function addPayloadFailed(res) {
    return !!(res && res.status && Number(res.status) >= 400);
  }

  function upsellIntervalVisible() {
    var root = $('[data-snx-cart]');
    return !root || root.getAttribute('data-upsell-interval') !== 'hide';
  }

  function intervalLabelForSize(size) {
    if (!upsellIntervalVisible()) return '';
    var key = packSizeKey(size);
    var root = $('[data-snx-cart]');
    if (key === '90') return (root && root.getAttribute('data-interval-90')) || 'Every 4 weeks';
    if (key === '180') return (root && root.getAttribute('data-interval-180')) || 'Every 3 months';
    return '';
  }

  var refreshBagsPdpOffer = null;
  var upsellOfferBySize = {};

  function upsellOfferForSize(size) {
    var key = packSizeKey(size);
    var stored = key ? upsellOfferBySize[key] : '';
    if (stored === 'subscription' || stored === 'one_time') return stored;
    return bagsSellingModeDefault() === 'subscription' ? 'subscription' : 'one_time';
  }

  function setUpsellOfferForSize(size, mode) {
    var key = packSizeKey(size);
    if (!key) return;
    upsellOfferBySize[key] = mode === 'subscription' ? 'subscription' : 'one_time';
  }

  function upsellCardSubscribe(card, size) {
    if (bagsPurchaseChoice() !== 'shopper_choice') return bagsLockedOrDefaultSubscribe();
    var sel = card && $('[data-snx-purchase-select]', card);
    if (sel && (sel.value === 'subscription' || sel.value === 'one_time')) {
      return sel.value === 'subscription';
    }
    return upsellOfferForSize(size || (card && card.getAttribute('data-size'))) === 'subscription';
  }

  function refreshUpsellCardOffer(card) {
    if (!card) return;
    var add = $('[data-snx-upsell-add]', card);
    var size = card.getAttribute('data-size') || '';
    var vid = add && Number(add.getAttribute('data-variant-id') || 0);
    var variant = bagOfferByVariantId(vid) || { id: vid, selling_plans: [] };
    if (!variant.size) variant.size = size;
    var subscribe = upsellCardSubscribe(card, size);
    var planId = bagSellingPlanId(variant, size, subscribe);
    $$('[data-snx-upsell-add]', card).forEach(function (btn) {
      if (planId) btn.setAttribute('data-selling-plan', String(planId));
      else btn.removeAttribute('data-selling-plan');
    });
    var price = $('[data-snx-upsell-price]', card);
    if (price) price.textContent = money(bagUnitPrice(variant, size, subscribe));
    var interval = $('[data-snx-upsell-interval]', card);
    if (interval) {
      var label = subscribe ? intervalLabelForSize(size) : '';
      interval.textContent = label;
      interval.hidden = !label;
    }
  }

  function setBagsOffer(mode) {
    var next = mode === 'subscription' ? 'subscription' : 'one_time';
    $$('[data-bags-offer]').forEach(function (el) {
      el.setAttribute('data-bags-offer', next);
    });
    var pdp = $('[data-snx-pdp][data-bags-mode="true"]');
    if (pdp) pdp.classList.toggle('is-subscribe', next === 'subscription');
    $$('[data-snx-purchase-mode]').forEach(function (btn) {
      var on = btn.getAttribute('data-snx-purchase-mode') === next;
      btn.classList.toggle('is-selected', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    hideBagsError();
    if (refreshBagsPdpOffer) refreshBagsPdpOffer();
    if (cartState) renderUpsells(cartState);
  }

  function applyThemeFromCart(cart) {
    var color = lastAddedColor;
    if (!color && cart) color = cartColor(cart);
    if (!color) {
      var pdp = $('[data-snx-pdp]');
      color = (pdp && pdp.getAttribute('data-selected-color')) || storedPdpColor();
    }
    setTheme(color || 'teal');
  }

  function isColorOptionName(name) {
    return /color|colour|couleur|farbe|colore|kolor/.test(String(name || '').toLowerCase());
  }

  function isSizeOptionName(name) {
    return /size|größe|grosse|taille|pack/.test(String(name || '').toLowerCase());
  }

  function optionIndex(product, names) {
    var opts = (product && product.options) || (product && product.options_with_values) || [];
    if (!opts.length) return -1;
    var lower = names.map(function (n) { return n.toLowerCase(); });
    var wantColor = lower.some(function (n) { return isColorOptionName(n); });
    var wantSize = lower.some(function (n) { return isSizeOptionName(n); });
    for (var i = 0; i < opts.length; i++) {
      var n = String(opts[i] && opts[i].name != null ? opts[i].name : opts[i]).toLowerCase();
      if (lower.indexOf(n) !== -1) return i;
      if (wantColor && isColorOptionName(n)) return i;
      if (wantSize && isSizeOptionName(n)) return i;
    }
    return -1;
  }

  function variantOpt(variant, idx) {
    if (!variant || idx < 0) return '';
    return String(variant['option' + (idx + 1)] || (variant.options && variant.options[idx]) || '');
  }

  function colorFromParts(parts) {
    var list = parts || [];
    var i;
    for (i = 0; i < list.length; i++) {
      var fam = family(list[i]);
      if (fam === 'pink' || fam === 'teal') return String(list[i]);
    }
    return '';
  }

  function itemOption(item, names) {
    var lower = names.map(function (n) { return n.toLowerCase(); });
    var wantColor = lower.some(function (n) { return isColorOptionName(n); });
    var wantSize = lower.some(function (n) { return isSizeOptionName(n); });
    var owv = item && item.options_with_values;
    if (owv && owv.length) {
      var i;
      for (i = 0; i < owv.length; i++) {
        var on = String(owv[i].name || '').toLowerCase();
        if (lower.indexOf(on) !== -1 || (wantColor && isColorOptionName(on)) || (wantSize && isSizeOptionName(on))) {
          return owv[i].value || '';
        }
      }
      if (wantColor) {
        var fromOwv = colorFromParts(owv.map(function (o) { return o.value; }));
        if (fromOwv) return fromOwv;
      }
    }
    if (wantColor) {
      var fromOpts = colorFromParts(item && (item.variant_options || item.options) || []);
      if (fromOpts) return fromOpts;
    }
    var title = String((item && item.variant_title) || '');
    if (title && title !== 'Default Title') {
      var parts = title.split(' / ');
      if (wantColor) {
        var fromTitle = colorFromParts(parts);
        if (fromTitle) return fromTitle;
      }
      if (wantSize) {
        for (var p = 0; p < parts.length; p++) {
          if (/\d/.test(parts[p])) return parts[p];
        }
      }
    }
    return '';
  }

  function colorMatch(a, b) {
    if (!a || !b) return false;
    if (window.SwoopColor && typeof SwoopColor.match === 'function') return !!SwoopColor.match(a, b);
    return String(a).toLowerCase() === String(b).toLowerCase();
  }

  function isCatcherItem(item) {
    var root = $('[data-snx-cart]');
    var id = root && root.getAttribute('data-catcher-id');
    if (id && id !== '0' && String(item.product_id) === String(id)) return true;
    var handle = String(item.handle || '').toLowerCase();
    if (handle === 'swoop' || handle.indexOf('catcher') !== -1) return true;
    return /catcher/i.test(item.product_title || '');
  }

  function isBagsItem(item, product) {
    var root = $('[data-snx-cart]');
    var id = (root && root.getAttribute('data-bags-id')) || (product && product.id);
    if (id && String(id) !== '0' && String(item.product_id) === String(id)) return true;
    return /bag/i.test(item.handle || '') || /bag/i.test(item.product_title || '');
  }

  function cartColor(cart) {
    var items = (cart && cart.items) || [];
    var i;
    var bags = bagsProduct();
    var pdp = $('[data-snx-pdp]');
    var hint = lastAddedColor
      || (pdp && pdp.getAttribute('data-selected-color'))
      || storedPdpColor();
    var hintFam = hint ? family(hint) : '';
    var catcherColors = [];
    var bagColors = [];
    for (i = items.length - 1; i >= 0; i--) {
      if (isCatcherItem(items[i])) {
        var catcherColor = itemOption(items[i], ['color', 'colour', 'farbe', 'couleur']);
        if (catcherColor) catcherColors.push(catcherColor);
      } else if (isBagsItem(items[i], bags)) {
        var bagColor = itemOption(items[i], ['color', 'colour', 'farbe', 'couleur']);
        if (bagColor) bagColors.push(bagColor);
      }
    }
    if (hintFam) {
      for (i = 0; i < catcherColors.length; i++) {
        if (family(catcherColors[i]) === hintFam) return catcherColors[i];
      }
    }
    if (catcherColors.length) return catcherColors[0];
    if (hintFam) {
      for (i = 0; i < bagColors.length; i++) {
        if (family(bagColors[i]) === hintFam) return bagColors[i];
      }
    }
    if (bagColors.length) return bagColors[0];
    return hint || '';
  }

  function maxBagSizeInCart(cart, product, colorName) {
    var max = 0;
    ((cart && cart.items) || []).forEach(function (it) {
      if (!isBagsItem(it, product)) return;
      if (colorName) {
        var itColor = itemOption(it, ['color', 'colour', 'farbe']);
        if (itColor && !colorMatch(itColor, colorName)) return;
      }
      var n = parseInt(itemOption(it, ['size', 'größe', 'taille']) || it.variant_title, 10);
      if (!isNaN(n) && n > max) max = n;
    });
    return max;
  }

  function variantInCart(cart, variantId) {
    return ((cart && cart.items) || []).some(function (it) {
      return String(it.variant_id || it.id) === String(variantId);
    });
  }

  function bagOfferInCart(cart, product, sizeRaw, colorName, variantId) {
    if (variantId && variantInCart(cart, variantId)) return true;
    return ((cart && cart.items) || []).some(function (it) {
      if (!isBagsItem(it, product)) return false;
      var itSize = itemOption(it, ['size', 'größe', 'taille']) || it.variant_title;
      if (!sizeMatch(itSize, sizeRaw)) return false;
      var itColor = itemOption(it, ['color', 'colour', 'farbe']);
      if (colorName && itColor) {
        return family(itColor) === family(colorName) || colorMatch(itColor, colorName);
      }
      return true;
    });
  }

  function catcherOfferInCart(cart, colorName, variantId) {
    if (variantId && variantInCart(cart, variantId)) return true;
    return ((cart && cart.items) || []).some(function (it) {
      if (!isCatcherItem(it)) return false;
      var itColor = itemOption(it, ['color', 'colour', 'farbe']);
      if (colorName && itColor) {
        return family(itColor) === family(colorName) || colorMatch(itColor, colorName);
      }
      return true;
    });
  }

  function variantColor(variant, cIdx) {
    var direct = variantOpt(variant, cIdx);
    if (direct) return direct;
    return colorFromParts([
      variant && variant.option1,
      variant && variant.option2,
      variant && variant.option3,
      variant && variant.title,
      variant && variant.public_title
    ]);
  }

  function resolveBagVariant(product, size, colorName) {
    if (!product) return null;
    var sIdx = optionIndex(product, ['size', 'größe', 'taille']);
    var cIdx = optionIndex(product, ['color', 'colour', 'farbe', 'couleur']);
    var wantFam = colorName ? family(colorName) : '';
    var list = (product.variants || []).filter(function (v) {
      if (sIdx >= 0 && !sizeMatch(variantOpt(v, sIdx), size) && !sizeMatch(v.title, size)) return false;
      return true;
    });
    if (wantFam) {
      var matched = list.filter(function (v) {
        var vColor = variantColor(v, cIdx);
        return colorMatch(vColor, colorName) || family(vColor) === wantFam;
      });
      if (matched.length) list = matched;
    }
    return list.find(function (v) { return v.available !== false; }) || list[0] || null;
  }

  function bagsSizes(product) {
    var idx = optionIndex(product, ['size', 'größe', 'taille']);
    var seen = {};
    var out = [];
    (product.variants || []).forEach(function (v) {
      var raw = idx >= 0 ? String(v['option' + (idx + 1)] || '') : '';
      if (!raw || seen[raw]) return;
      seen[raw] = true;
      var n = parseInt(raw, 10);
      out.push({ raw: raw, n: isNaN(n) ? 0 : n });
    });
    out.sort(function (a, b) { return a.n - b.n; });
    return out;
  }

  function imageSrc(img) {
    if (!img) return '';
    if (typeof img === 'string') return img;
    return img.src || (img.preview_image && img.preview_image.src) || '';
  }

  function variantImage(product, variant) {
    var src = imageSrc(variant && (variant.featured_image || variant.image || variant.featured_media));
    if (src) return src;
    var id = variant && variant.id;
    var images = (product && product.images) || [];
    var i;
    if (id) {
      for (i = 0; i < images.length; i++) {
        var vids = images[i].variant_ids || [];
        if (vids.indexOf(id) !== -1 || vids.indexOf(String(id)) !== -1) {
          src = imageSrc(images[i]);
          if (src) return src;
        }
        if (variant.image_id != null && String(images[i].id) === String(variant.image_id)) {
          src = imageSrc(images[i]);
          if (src) return src;
        }
      }
    }
    return imageSrc(product && product.featured_image);
  }

  var bagOfferMapCache;
  function bagOfferMap() {
    if (bagOfferMapCache !== undefined) return bagOfferMapCache;
    var el = $('[data-snx-bag-offers]') || $('[data-snx-bag-images]');
    try { bagOfferMapCache = el ? JSON.parse(el.textContent) : {}; }
    catch (err) { bagOfferMapCache = {}; }
    return bagOfferMapCache || {};
  }

  function bagOfferRow(fam, size) {
    if (!fam) return null;
    var map = bagOfferMap();
    var n = parseInt(size, 10);
    var row = map[fam + '-' + n] || map[fam + '-' + size] || null;
    if (typeof row === 'string') return { image: row };
    return row;
  }

  function bagMappedImage(fam, size) {
    var row = bagOfferRow(fam, size);
    return (row && row.image) || '';
  }

  function sizedImage(src) {
    var url = String(src || '');
    if (!url || /[?&]width=/.test(url)) return url;
    return url.indexOf('?') >= 0 ? url + '&width=600' : url + '?width=600';
  }

  function nextBagOffers(cart, product, colorName, opts) {
    var root = $('[data-snx-cart]');
    var color = colorName || cartColor(cart);
    var preferred = String((root && root.getAttribute('data-upsell-sizes')) || '90,180')
      .split(',')
      .map(function (s) { return s.trim(); })
      .filter(Boolean)
      .slice(0, 2);
    var picks = [];
    var cIdx = optionIndex(product, ['color', 'colour', 'farbe', 'couleur']);
    var wantFam = color ? family(color) : '';
    if (wantFam !== 'pink' && wantFam !== 'teal') wantFam = color ? 'teal' : '';
    var keepOwned = opts && opts.includeInCart;
    preferred.forEach(function (sizeRaw) {
      var row = bagOfferRow(wantFam, sizeRaw);
      var variant = row && row.id
        ? { id: row.id, price: row.price, featured_image: row.image, selling_plans: row.selling_plans, size: row.size || sizeRaw }
        : resolveBagVariant(product, sizeRaw, color);
      if (!variant) return;
      if (!keepOwned && bagOfferInCart(cart, product, sizeRaw, color || wantFam, variant.id)) return;
      picks.push({
        size: sizeRaw,
        variant: variant,
        color: (row && row.color) || variantColor(variant, cIdx) || color,
        family: wantFam,
        image: row && row.image,
        type: 'bags',
        product: product
      });
    });
    return picks;
  }

  var catcherOfferMapCache;
  function catcherOfferMap() {
    if (catcherOfferMapCache !== undefined) return catcherOfferMapCache;
    var el = $('[data-snx-catcher-offers]');
    try { catcherOfferMapCache = el ? JSON.parse(el.textContent) : {}; }
    catch (err) { catcherOfferMapCache = {}; }
    return catcherOfferMapCache || {};
  }

  function catcherOfferRow(fam) {
    if (!fam) return null;
    var row = catcherOfferMap()[fam];
    if (typeof row === 'string') return { image: row };
    return row || null;
  }

  function nextCatcherOffers(cart, product, opts) {
    if (!product) return [];
    var both = !opts || opts.both !== false;
    var keepOwned = opts && opts.includeInCart;
    var wantFam = family(cartColor(cart));
    var cIdx = optionIndex(product, ['color', 'colour', 'farbe', 'couleur']);
    var seen = {};
    var picks = [];
    (product.variants || []).forEach(function (v) {
      var color = variantColor(v, cIdx);
      var fam = family(color);
      if (!fam || seen[fam]) return;
      if (!both && wantFam && fam !== wantFam) return;
      if (v.available === false) return;
      if (!keepOwned && catcherOfferInCart(cart, color, v.id)) return;
      seen[fam] = true;
      var row = catcherOfferRow(fam);
      picks.push({
        size: (row && row.color) || color,
        variant: row && row.id ? { id: row.id, price: row.price, featured_image: row.image } : v,
        color: (row && row.color) || color,
        family: fam,
        image: row && row.image,
        type: 'catcher',
        product: product
      });
    });
    picks.sort(function (a, b) {
      if (a.family === b.family) return 0;
      return a.family === 'teal' ? -1 : 1;
    });
    return both ? picks.slice(0, 2) : picks.slice(0, 1);
  }

  function catcherQty(cart) {
    return ((cart && cart.items) || []).reduce(function (n, it) {
      return n + (isCatcherItem(it) ? Number(it.quantity) || 0 : 0);
    }, 0);
  }

  function catcherFamilyInCart(cart, colorName) {
    if (!colorName) return false;
    var fam = family(colorName);
    return ((cart && cart.items) || []).some(function (it) {
      if (!isCatcherItem(it)) return false;
      var color = itemOption(it, ['color', 'colour', 'farbe', 'couleur']);
      return !!color && family(color) === fam;
    });
  }

  function newestCatcherColor(cart) {
    var items = (cart && cart.items) || [];
    var i;
    for (i = 0; i < items.length; i++) {
      if (!isCatcherItem(items[i])) continue;
      var color = itemOption(items[i], ['color', 'colour', 'farbe', 'couleur']);
      if (color) return color;
    }
    return '';
  }

  function upsellMode(cart) {
    if (!cart || !cart.item_count) return 'hide';
    var catchers = catcherQty(cart);
    var hasBags = cartHasBags(cart);
    var hasCatcher = catchers > 0;

    /* A bag was just taken from Gift them matching Bags, so that offer is finished. */
    if (giftBagsCleared) return 'hide';
    /* Matching bags for the catcher just chosen here, until one of those bags is added. */
    if (giftBagColor) return 'gift-bags';
    /* A catcher just chosen here, even when colour detection missed. */
    if (lastAddedFromUpsell && lastAddedKind === 'catcher' && lastAddedHadCatcher && !lastAddedHadBags) return 'gift-bags';
    /* Two catchers already in the cart. */
    if (catchers >= 2) return 'gift-bags';
    /* Bags just chosen here, with a catcher already in the cart: offer both catcher colours. */
    if (lastAddedFromUpsell && hasCatcher && (lastAddedKind === 'bags' || lastAddedHadBags)) return 'catcher';
    /* Catcher already paired with bags, including bags chosen on the product page. */
    if (hasCatcher && hasBags) return 'catcher';
    /* Bags only. */
    if (hasBags && !hasCatcher) return 'catcher';
    /* Catcher only: 90 and 180 bags in that colour. */
    if (hasCatcher) return 'bags';
    return 'hide';
  }

  function upsellBagColor(cart) {
    if (giftBagColor) return giftBagColor;
    if (lastAddedColor && (lastAddedKind === 'catcher' || lastAddedKind === 'both')) return lastAddedColor;
    return cartColor(cart) || lastAddedColor || '';
  }

  function paintUpsellCard(card, offer, product) {
    if (!card || !offer || !offer.variant) {
      if (card) card.hidden = true;
      return;
    }
    var variant = offer.variant;
    var source = offer.product || product;
    var fam = offer.family || family(offer.color || '');
    var root = $('[data-snx-cart]');
    card.hidden = false;
    card.setAttribute('data-size', offer.size);
    card.setAttribute('data-offer-type', offer.type || '');
    card.setAttribute('data-offer-color', offer.color || '');
    card.classList.toggle('snx-upsell-card--pink', fam === 'pink');
    var sel = $('[data-snx-purchase-select]', card);
    if (sel && offer.type === 'bags') {
      var mode = upsellOfferForSize(offer.size);
      if (sel.value !== mode) sel.value = mode;
    }
    var subscribe = offer.type === 'bags' && upsellCardSubscribe(card, offer.size);
    $$('[data-snx-upsell-add]', card).forEach(function (add) {
      add.setAttribute('data-variant-id', String(variant.id));
      var planId = offer.type === 'bags' ? bagSellingPlanId(variant, offer.size, subscribe) : 0;
      if (planId) add.setAttribute('data-selling-plan', String(planId));
      else add.removeAttribute('data-selling-plan');
    });
    var img = $('img', card);
    var src = offer.image || bagMappedImage(fam, offer.size) || variantImage(source, variant);
    if (img && src) {
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.setAttribute('src', sizedImage(src));
      img.alt = (source && source.title) || '';
    }
    var name = $('[data-snx-upsell-name]', card);
    if (name) {
      if (offer.type === 'catcher') {
        name.textContent = fam === 'pink'
          ? ((root && root.getAttribute('data-color-2-label')) || 'Poupette Pink')
          : ((root && root.getAttribute('data-color-1-label')) || 'SwoopMan Turquoise');
      }
      else name.textContent = offer.size + ' ' + ((root && root.getAttribute('data-bags-word')) || (source && source.title) || 'Swoop Bags');
    }
    var price = $('[data-snx-upsell-price]', card);
    if (price) {
      var cents = offer.type === 'bags' ? bagUnitPrice(variant, offer.size, subscribe) : Number(variant.price || 0);
      price.textContent = money(cents);
    }
    var interval = $('[data-snx-upsell-interval]', card);
    if (interval) {
      var label = offer.type === 'bags' && subscribe ? intervalLabelForSize(offer.size) : '';
      interval.textContent = label;
      interval.hidden = !label;
    }
  }

  function renderUpsells(cart) {
    var wrap = $('[data-snx-upsell]');
    var grid = $('[data-snx-upsell-grid]');
    var root = $('[data-snx-cart]');
    if (!wrap || !grid) return;
    var bags = bagsProduct();
    var catcher = catcherProduct();
    var cards = $$('[data-snx-upsell-card]', grid);
    if (!cart || !cart.item_count) {
      giftBagsCleared = false;
      giftBagColor = '';
      wrap.hidden = true;
      return;
    }
    if (giftBagColor && !catcherFamilyInCart(cart, giftBagColor)) giftBagColor = '';
    var mode = upsellMode(cart);
    if (mode === 'hide') {
      wrap.hidden = true;
      upsellStep = '';
      return;
    }
    var bagColor = upsellBagColor(cart);
    if (mode === 'gift-bags' && !giftBagColor && !lastAddedColor) {
      bagColor = newestCatcherColor(cart) || bagColor;
    }
    var offers = mode === 'catcher'
      ? nextCatcherOffers(cart, catcher, { both: true, includeInCart: true })
      : nextBagOffers(cart, bags, bagColor, { includeInCart: mode === 'gift-bags' });
    var title = $('[data-snx-upsell-title]');
    if (title && root) {
      var heading = root.getAttribute('data-upsell-heading') || title.textContent;
      if (mode === 'catcher') heading = root.getAttribute('data-upsell-heading-catcher') || 'Best gift for a dog owner';
      else if (mode === 'gift-bags' && (cartHasBags(cart) || giftBagColor)) {
        heading = root.getAttribute('data-upsell-heading-gift') || 'Gift them matching Bags';
      }
      title.textContent = decodeEntities(heading);
    }
    cards.forEach(function (card, i) {
      paintUpsellCard(card, offers[i], mode === 'catcher' ? catcher : bags);
    });
    grid.classList.toggle('is-single', offers.length === 1);
    wrap.hidden = offers.length === 0;
    if (offers.length) upsellStep = mode;
    var showPurchase = mode !== 'catcher' && offers.length > 0 && bagsPurchaseChoice() === 'shopper_choice';
    $$('[data-snx-upsell-purchase]', wrap).forEach(function (purchase) {
      purchase.hidden = !showPurchase;
    });
  }

  var lastAddedTitle = '';
  var lastAddedColor = '';
  var lastAddedKind = '';
  var lastAddedHadCatcher = false;
  var lastAddedHadBags = false;
  var lastAddedFromUpsell = false;
  var giftBagColor = '';
  var giftBagsCleared = false;
  var upsellStep = '';

  function addedItems(res) {
    if (!res || res.status) return [];
    if (res.items && res.items.length) return res.items;
    if (res.variant_id || res.product_id) return [res];
    return [];
  }

  function rememberAdded(res, fallback) {
    var items = addedItems(res);
    var item = items.length ? items[items.length - 1] : null;
    var fb = fallback || {};
    var colorNames = ['color', 'colour', 'farbe', 'couleur'];
    var catcherItem = null;
    var bagsItem = null;
    items.forEach(function (it) {
      if (isCatcherItem(it)) catcherItem = it;
      else if (isBagsItem(it)) bagsItem = it;
    });
    lastAddedFromUpsell = !!fb.fromUpsell;
    var sawCatcher = !!catcherItem;
    var sawBags = !!bagsItem;
    if (!sawCatcher && (fb.kind === 'catcher' || fb.kind === 'both')) sawCatcher = true;
    if (!sawBags && (fb.kind === 'bags' || fb.includesBags)) sawBags = true;
    lastAddedHadCatcher = sawCatcher;
    lastAddedHadBags = sawBags;
    if (sawCatcher && sawBags) lastAddedKind = 'both';
    else if (sawCatcher) lastAddedKind = 'catcher';
    else if (sawBags) lastAddedKind = 'bags';
    else if (fb.kind) lastAddedKind = fb.kind;
    lastAddedTitle = displayItemTitle(item) || brandSwoop(fb.title || lastAddedTitle || '');
    var detectedColor = (catcherItem && itemOption(catcherItem, colorNames))
      || (item && itemOption(item, colorNames))
      || '';
    if (!detectedColor && fb.color && (sawCatcher || !lastAddedColor)) detectedColor = fb.color;
    if (detectedColor) lastAddedColor = detectedColor;
    if (fb.fromUpsell && upsellStep === 'gift-bags' && sawBags && !sawCatcher) {
      giftBagsCleared = true;
      giftBagColor = '';
    } else if (fb.fromUpsell && sawCatcher && !sawBags) {
      giftBagsCleared = false;
      giftBagColor = detectedColor || fb.color || lastAddedColor || giftBagColor;
    } else if (!fb.fromUpsell) {
      upsellStep = '';
      giftBagColor = '';
      if (sawCatcher) giftBagsCleared = false;
    }
  }

  function paintConfirm(cart) {
    var confirm = $('[data-snx-confirm-text]');
    var root = $('[data-snx-cart]');
    if (!confirm || !root) return;
    if (cart && shippingUnlocked(cart)) {
      confirm.textContent = decodeEntities(root.getAttribute('data-shipping-unlocked') || "You've unlocked FREE SHIPPING 📦🚚");
      return;
    }
    if (!lastAddedTitle) return;
    var tpl = decodeEntities(root.getAttribute('data-confirm') || '{title} is now in your cart.');
    confirm.textContent = replaceTpl(tpl, { title: lastAddedTitle });
  }

  function paintCart(cart) {
    cartState = cart;
    syncBadges(cart);
    applyThemeFromCart(cart);
    renderItems(cart);
    renderShipRow(cart);
    renderUpsells(cart);
    paintConfirm(cart);
    var empty = !cart || !cart.item_count;
    $$('[data-snx-sheet]').forEach(function (sheet) {
      renderRewards(sheet, cart);
      renderFooter(sheet, cart);
      if (sheet.getAttribute('data-snx-sheet') === 'recap') {
        var footer = $('.snx-sheet__footer', sheet);
        if (footer) footer.hidden = empty;
      }
    });
  }

  function refreshCart() {
    return getCart().then(paintCart);
  }

  var sheetGen = 0;

  function openSheet(name) {
    sheetGen += 1;
    var overlay = $('[data-snx-overlay]');
    var sheet = $('[data-snx-sheet="' + name + '"]');
    $$('[data-snx-sheet]').forEach(function (el) {
      if (el !== sheet) {
        el.classList.remove('is-open');
        el.hidden = true;
      }
    });
    if (overlay) {
      overlay.hidden = false;
      void overlay.offsetWidth;
      overlay.classList.add('is-open');
    }
    if (sheet) {
      sheet.hidden = false;
      if (cartState) {
        renderRewards(sheet, cartState);
        renderFooter(sheet, cartState);
        if (name === 'upsell') renderUpsells(cartState);
      }
      void sheet.offsetWidth;
      sheet.classList.add('is-open');
    }
    lock(true);
  }

  function closeSheets() {
    var overlay = $('[data-snx-overlay]');
    if (overlay) overlay.classList.remove('is-open');
    $$('[data-snx-sheet]').forEach(function (el) { el.classList.remove('is-open'); });
    var gen = sheetGen;
    window.setTimeout(function () {
      if (gen !== sheetGen) return;
      if (overlay) overlay.hidden = true;
      $$('[data-snx-sheet]').forEach(function (el) { el.hidden = true; });
    }, 500);
    if (!document.documentElement.classList.contains('snx-nav-open')) lock(false);
  }

  function desktopNav() {
    return window.matchMedia('(min-width: 990px)').matches;
  }

  function mountNav() {
    var nav = $('[data-snx-nav]');
    var bar = $('[data-snx-header-bar]');
    if (!nav) return nav;
    if (desktopNav()) {
      if (bar && nav.parentNode !== bar) bar.appendChild(nav);
    } else if (nav.parentNode !== document.body) {
      document.body.appendChild(nav);
    }
    return nav;
  }

  function paintNavToggle(open) {
    var btn = $('[data-snx-nav-toggle]');
    if (!btn) return;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    btn.setAttribute(
      'aria-label',
      open
        ? (btn.getAttribute('data-close-label') || 'Close menu')
        : (btn.getAttribute('data-open-label') || 'Open menu')
    );
  }

  function openNav() {
    var nav = mountNav();
    if (!nav) return;
    nav.hidden = false;
    nav.removeAttribute('hidden');
    nav.classList.add('is-open');
    document.documentElement.classList.add('snx-nav-open');
    paintNavToggle(true);
    if (window.__snxNavSpotlightPaint) window.__snxNavSpotlightPaint();
    if (!desktopNav()) {
      lock(true);
      var closeBtn = $('[data-snx-close-nav]', nav);
      if (closeBtn) closeBtn.focus();
    }
  }

  function closeNav() {
    var nav = $('[data-snx-nav]');
    if (nav) {
      nav.hidden = true;
      nav.classList.remove('is-open');
    }
    document.documentElement.classList.remove('snx-nav-open');
    paintNavToggle(false);
    if (!$('[data-snx-sheet]:not([hidden])')) lock(false);
    else if ($$('[data-snx-sheet]').every(function (el) { return el.hidden; })) lock(false);
  }

  function closestToggle(node) {
    while (node && node !== document && node !== window) {
      if (node.getAttribute && node.getAttribute('data-snx-nav-toggle') !== null) return node;
      node = node.parentNode || node.parentElement;
    }
    return null;
  }

  function toggleNav(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    }
    if (!kitIsNext()) return;
    if (document.documentElement.classList.contains('snx-nav-open')) closeNav();
    else openNav();
  }

  window.__snxToggleNav = toggleNav;

  var readyToggle = document.querySelector('[data-snx-nav-toggle]');
  if (readyToggle) readyToggle.onclick = toggleNav;

  function initNavSpotlight() {
    var root = $('[data-snx-nav-spotlight]');
    if (!root || root.getAttribute('data-snx-ready')) return;
    var track = $('[data-snx-nav-track]', root);
    var row = $('[data-snx-nav-row]', root) || track;
    var slides = $$('[data-snx-nav-slide]', root);
    var dots = $$('[data-snx-nav-dot]', root);
    var caption = $('[data-snx-nav-caption-out]', root);
    if (slides.length < 2) return;
    root.setAttribute('data-snx-ready', '1');
    var index = 0;
    var dragging = false;
    var dragged = false;
    var pressLink = null;
    var startX = 0;
    var lastX = 0;

    function desktopSlider() {
      return window.matchMedia('(min-width: 990px)').matches;
    }

    function perView() {
      if (!desktopSlider()) return 1;
      var col = root.closest('.snx-nav__col--featured') || root;
      return (col.clientWidth || 0) >= 340 ? Math.min(2, slides.length) : 1;
    }

    function cardStep() {
      if (!slides[0]) return 224;
      var gap = parseFloat(window.getComputedStyle(row).gap) || 16;
      return (slides[0].offsetWidth || 208) + gap;
    }

    function clampIndex(next) {
      var max = Math.max(0, slides.length - perView());
      if (perView() === 1) return (next + slides.length) % slides.length;
      return Math.min(Math.max(0, next), max);
    }

    function paint(offsetPx) {
      var per = perView();
      root.setAttribute('data-snx-per', String(per));
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index || (per > 1 && i === index + 1));
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
      if (caption) {
        caption.textContent = slides[index].getAttribute('data-snx-nav-caption') || '';
      }
      if (!row) return;
      if (!desktopSlider()) {
        row.style.transform = '';
        return;
      }
      row.style.transform = 'translate3d(' + ((-index * cardStep()) + (offsetPx || 0)) + 'px, 0, 0)';
    }

    function show(next) {
      index = clampIndex(next);
      paint(0);
    }

    root.addEventListener('click', function (e) {
      var dot = e.target.closest('[data-snx-nav-dot]');
      if (!dot) return;
      e.preventDefault();
      e.stopPropagation();
      show(Number(dot.getAttribute('data-snx-nav-dot')) || 0);
    });

    slides.forEach(function (slide) {
      slide.addEventListener('click', function (e) {
        if (dragged) {
          e.preventDefault();
          e.stopPropagation();
        }
      });
    });

    if (track) {
      track.addEventListener('pointerdown', function (e) {
        if (!desktopSlider() || e.button) return;
        dragging = true;
        dragged = false;
        startX = lastX = e.clientX;
        pressLink = e.target && e.target.closest ? e.target.closest('[data-snx-nav-slide]') : null;
        track.classList.add('is-dragging');
        try { track.setPointerCapture(e.pointerId); } catch (err) {}
      });
      track.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        lastX = e.clientX;
        paint(lastX - startX);
      });
      function endDrag(e) {
        if (!dragging) return;
        dragging = false;
        track.classList.remove('is-dragging');
        var step = cardStep();
        var dx = lastX - startX;
        var slid = dx < -40 || dx < -step * 0.18 || dx > 40 || dx > step * 0.18;
        dragged = slid;
        if (dx < -40 || dx < -step * 0.18) show(index + 1);
        else if (dx > 40 || dx > step * 0.18) show(index - 1);
        else show(index);
        if (slid || !e || e.type === 'pointercancel') return;
        if (pressLink && pressLink.getAttribute('href')) window.location.assign(pressLink.href);
      }
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('dragstart', function (e) { e.preventDefault(); });
    }

    window.addEventListener('resize', function () {
      paint(0);
    });
    window.__snxNavSpotlightPaint = function () { paint(0); };
    paint(0);
  }

  function initHeaderChrome() {
    var header = $('.header--swoop[data-swoop-header-chrome]');
    var shell = $('[data-snx-header]');
    var bar = $('[data-snx-header-bar]');
    if (!header || !shell || !bar || (window.Shopify && Shopify.designMode)) return;

    var enterAt = 72;
    var leaveAt = 36;
    var ticking = false;
    var pinning = false;

    function pinBar(stick) {
      if (pinning) return;
      var placed = stick ? bar.parentNode === document.body : bar.parentNode === shell;
      if (placed && header.classList.contains('is-scroll-chrome') === stick && bar.classList.contains('is-sticky') === stick) {
        return;
      }
      pinning = true;
      var y = window.scrollY || 0;
      header.classList.toggle('is-scroll-chrome', stick);
      header.classList.remove('is-chrome-hidden', 'is-chrome-revealed');
      bar.classList.toggle('is-sticky', stick);
      document.documentElement.classList.toggle('is-snx-header-sticky', stick);
      if (stick && bar.parentNode !== document.body) document.body.appendChild(bar);
      else if (!stick && bar.parentNode !== shell) shell.appendChild(bar);
      if ((window.scrollY || 0) !== y) window.scrollTo(0, y);
      pinning = false;
    }

    function apply() {
      if (pinning) return;
      if (!active()) {
        pinBar(false);
        return;
      }
      if (document.documentElement.classList.contains('snx-nav-open')) return;
      if (document.documentElement.classList.contains('snx-lock')) return;
      var y = window.scrollY || 0;
      if (y >= enterAt) pinBar(true);
      else if (y <= leaveAt) pinBar(false);
    }

    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        apply();
      });
    }, { passive: true });

    window.addEventListener('resize', apply);
    apply();
  }

  function initNav() {
    if (window.__snxNav) return;
    window.__snxNav = true;
    mountNav();
    initNavSpotlight();

    document.addEventListener('click', function (e) {
      if (!kitIsNext()) return;
      if (closestToggle(e.target)) return;
      var closeEl = e.target.closest ? e.target.closest('[data-snx-close-nav]') : null;
      var cartEl = e.target.closest ? e.target.closest('[data-snx-open-cart]') : null;
      var sheetEl = e.target.closest ? e.target.closest('[data-snx-close-sheet]') : null;
      if (closeEl) {
        e.preventDefault();
        closeNav();
      } else if (cartEl) {
        e.preventDefault();
        closeNav();
        openSheet('recap');
        refreshCart();
      } else if (sheetEl) {
        e.preventDefault();
        closeSheets();
      }
    }, true);
    document.addEventListener('keydown', function (e) {
      if (!kitIsNext() || e.key !== 'Escape') return;
      if (document.documentElement.classList.contains('snx-nav-open')) closeNav();
    });
    window.addEventListener('resize', mountNav);
  }

  function initGallery(root) {
    $$('[data-snx-gallery-set]', root).forEach(function (set) {
      if (set.getAttribute('data-snx-gallery-ready')) return;
      var track = $('[data-snx-gallery-track]', set);
      var slides = $$('[data-snx-slide]', set);
      var thumbs = $$('[data-snx-thumb]', set);
      var indexEl = $('[data-snx-gallery-index]', set);
      var dots = $$('[data-snx-dot]', set);
      if (!track || !slides.length) return;
      set.setAttribute('data-snx-gallery-ready', '1');

      function desktopGallery() {
        return window.matchMedia('(min-width: 990px)').matches;
      }

      function indexFromScroll() {
        var left = track.getBoundingClientRect().left + 24;
        var best = 0;
        var bestDist = Infinity;
        slides.forEach(function (slide, i) {
          var media = slide.querySelector('img, video') || slide;
          var dist = Math.abs(media.getBoundingClientRect().left - left);
          if (dist < bestDist) {
            bestDist = dist;
            best = i;
          }
        });
        return best;
      }

      function currentIndex() {
        if (desktopGallery()) {
          var current = slides.findIndex(function (slide) {
            return slide.classList.contains('is-current');
          });
          return current >= 0 ? current : 0;
        }
        return indexFromScroll();
      }

      function paint(i) {
        if (typeof i !== 'number' || i !== i) i = currentIndex();
        i = Math.max(0, Math.min(slides.length - 1, Math.round(i)));
        slides.forEach(function (slide, si) {
          slide.classList.toggle('is-current', si === i);
        });
        thumbs.forEach(function (thumb, ti) {
          thumb.classList.toggle('is-active', ti === i);
        });
        if (indexEl) indexEl.textContent = (i + 1) + '/' + slides.length;
        dots.forEach(function (dot, di) {
          dot.classList.toggle('is-active', di === i);
        });
      }

      function goTo(i) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        paint(i);
        if (desktopGallery()) return;
        var slide = slides[i];
        var media = slide.querySelector('img, video');
        var inset = media ? (media.offsetLeft - slide.offsetLeft) : 16;
        track.scrollTo({ left: Math.max(0, slide.offsetLeft + inset - 24), behavior: 'smooth' });
      }

      function go(delta) {
        goTo(currentIndex() + delta);
      }

      track.addEventListener('scroll', function () {
        window.requestAnimationFrame(function () {
          if (desktopGallery()) return;
          paint(indexFromScroll());
        });
      }, { passive: true });
      var prev = $('[data-snx-gallery-prev]', set);
      var next = $('[data-snx-gallery-next]', set);
      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });
      dots.forEach(function (dot, di) {
        dot.addEventListener('click', function () { goTo(di); });
      });
      thumbs.forEach(function (thumb, ti) {
        thumb.addEventListener('click', function () { goTo(ti); });
      });
      set._snxGoTo = goTo;

      var drag = { on: false, startX: 0, startLeft: 0, moved: false };
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return;
        if (desktopGallery()) return;
        drag.on = true;
        drag.moved = false;
        drag.startX = e.clientX;
        drag.startLeft = track.scrollLeft;
        track.classList.add('is-dragging');
        try { track.setPointerCapture(e.pointerId); } catch (err) {}
      });
      track.addEventListener('pointermove', function (e) {
        if (!drag.on) return;
        var dx = e.clientX - drag.startX;
        if (Math.abs(dx) > 4) drag.moved = true;
        track.scrollLeft = drag.startLeft - dx;
      });
      function endDrag(e) {
        if (!drag.on) return;
        drag.on = false;
        track.classList.remove('is-dragging');
        if (drag.moved) goTo(currentIndex());
      }
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('click', function (e) {
        if (drag.moved) e.preventDefault();
        drag.moved = false;
      }, true);

      paint();
    });
  }

  function initPdp() {
    var pdp = $('[data-snx-pdp]');
    if (!pdp) return;

    var atc = $('[data-snx-atc]');
    var buyBtn = $('[data-snx-buy-btn]');
    var priceEls = $$('[data-snx-atc-price]');
    var metaEl = $('[data-snx-atc-meta]');
    var btns = $$('[data-snx-atc-btn]');
    var inclusion = pdp.getAttribute('data-inclusion') || '';
    var bagsMode = pdp.getAttribute('data-bags-mode') === 'true';
    var bagsWord = pdp.getAttribute('data-bags-word') || 'Bags';
    var variants = [];
    try {
      var mapEl = $('[data-snx-variant-map]', pdp);
      variants = mapEl ? JSON.parse(mapEl.textContent || '[]') : [];
    } catch (err) {
      variants = [];
    }
    var colorCards = $$('[data-snx-color-card]', pdp);
    var sizePills = $$('[data-snx-size]', pdp);
    var gallerySets = $$('[data-snx-gallery-set]', pdp);
    var qtyPills = $$('[data-snx-color-qty]', pdp);
    var urlTimer = 0;
    var BAG_QTY_MAX = 10;
    var bagQtyStore = {};

    function qtyPill(name) {
      return qtyPills.find(function (el) {
        return colorMatch(el.getAttribute('data-color'), name) || el.getAttribute('data-color') === name;
      }) || null;
    }

    function qtyFor(name) {
      var pill = qtyPill(name);
      if (!pill) return 0;
      return Math.max(0, parseInt(($('[data-snx-color-qty-num]', pill) || {}).textContent, 10) || 0);
    }

    function bagColorKey(name) {
      return String(name || '').trim().toLowerCase();
    }

    function ensureBagColor(name) {
      var key = bagColorKey(name);
      if (!key) return null;
      if (!bagQtyStore[key]) bagQtyStore[key] = { label: String(name || '').trim(), qtys: {}, locked: {} };
      else {
        if (name) bagQtyStore[key].label = String(name).trim();
        if (!bagQtyStore[key].locked) bagQtyStore[key].locked = {};
      }
      return bagQtyStore[key];
    }

    function bagQty(color, size) {
      var bucket = ensureBagColor(color);
      if (!bucket || !size) return 0;
      return Math.max(0, parseInt(bucket.qtys[String(size)] || 0, 10) || 0);
    }

    function isBagQtyLocked(color, size) {
      var bucket = ensureBagColor(color);
      return !!(bucket && size && bucket.locked[String(size)]);
    }

    function setBagQty(color, size, qty, userSet) {
      var bucket = ensureBagColor(color);
      if (!bucket || !size) return;
      var key = String(size);
      var next = Math.max(0, Math.min(BAG_QTY_MAX, qty));
      bucket.qtys[key] = next;
      if (next <= 0) {
        delete bucket.locked[key];
        return;
      }
      if (userSet) bucket.locked[key] = true;
    }

    function keepBagQty(color, size) {
      var q = bagQty(color, size);
      return q > 1 || (q > 0 && isBagQtyLocked(color, size));
    }

    function pruneUnlockedBagQtys() {
      Object.keys(bagQtyStore).forEach(function (key) {
        var bucket = bagQtyStore[key];
        var color = (bucket && bucket.label) || key;
        Object.keys((bucket && bucket.qtys) || {}).forEach(function (size) {
          if (keepBagQty(color, size)) return;
          bucket.qtys[size] = 0;
          if (bucket.locked) delete bucket.locked[size];
        });
      });
    }

    function currentBagSize() {
      return pdp.getAttribute('data-selected-size') || (sizePills[0] && sizePills[0].getAttribute('data-size')) || '';
    }

    function currentBagColor() {
      return pdp.getAttribute('data-selected-color') || '';
    }

    function paintBagQtyUi() {
      if (!bagsMode) return;
      var color = currentBagColor();
      var size = currentBagSize();
      colorCards.forEach(function (card) {
        var name = card.getAttribute('data-color');
        var q = bagQty(name, size);
        var focused = colorMatch(name, color) || name === color;
        card.classList.toggle('is-selected', focused || q > 0);
        card.setAttribute('aria-pressed', focused || q > 0 ? 'true' : 'false');
        setQty(name, q);
      });
      sizePills.forEach(function (pill) {
        var pack = pill.getAttribute('data-size') || '';
        var q = bagQty(color, pack);
        var focused = String(pack) === String(size);
        pill.classList.toggle('is-selected', focused || q > 0);
        pill.setAttribute('aria-pressed', focused || q > 0 ? 'true' : 'false');
      });
    }

    function countedBagQty() {
      return qtyEntries().items.reduce(function (n, it) { return n + it.quantity; }, 0);
    }

    function syncBagAtcState() {
      if (!bagsMode) return;
      var hasQty = countedBagQty() > 0;
      var v = findBagVariant(currentBagColor(), currentBagSize());
      var available = !v || v.available !== false;
      btns.forEach(function (el) {
        el.disabled = !hasQty || !available;
      });
      updateAtcPrice();
    }

    function focusBag(color, size) {
      var nextColor = color || currentBagColor();
      var nextSize = size || currentBagSize();
      var colorChanged = nextColor && currentBagColor() && !colorMatch(currentBagColor(), nextColor) && currentBagColor() !== nextColor;
      var sizeChanged = nextSize && String(currentBagSize()) !== String(nextSize);
      if (colorChanged || sizeChanged) pruneUnlockedBagQtys();
      if (!keepBagQty(nextColor, nextSize)) setBagQty(nextColor, nextSize, 1, false);
      applyBagSelection(nextColor, nextSize);
      paintBagQtyUi();
      syncBagAtcState();
    }

    function totalColorQty() {
      var total = 0;
      colorCards.forEach(function (card) {
        total += qtyFor(card.getAttribute('data-color'));
      });
      return total;
    }

    function syncColorSelection() {
      if (bagsMode) {
        paintBagQtyUi();
        return;
      }
      colorCards.forEach(function (card) {
        var on = qtyFor(card.getAttribute('data-color')) > 0;
        card.classList.toggle('is-selected', on);
        card.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    function applyCardClickQty(name) {
      var total = totalColorQty();
      var selectedQty = qtyFor(name);
      if (total <= 1 && selectedQty < 1) {
        colorCards.forEach(function (card) {
          var cardName = card.getAttribute('data-color');
          var on = colorMatch(cardName, name) || cardName === name;
          setQty(cardName, on ? 1 : 0);
        });
        return;
      }
      if (selectedQty < 1) setQty(name, 1);
    }

    function setQty(name, qty) {
      var pill = qtyPill(name);
      if (!pill) return;
      $('[data-snx-color-qty-num]', pill).textContent = String(qty);
    }

    function qtyEntries() {
      var teal = 0;
      var pink = 0;
      var items = [];
      if (bagsMode) {
        Object.keys(bagQtyStore).forEach(function (key) {
          var bucket = bagQtyStore[key];
          var color = (bucket && bucket.label) || key;
          Object.keys((bucket && bucket.qtys) || {}).forEach(function (size) {
            var q = Math.max(0, parseInt(bucket.qtys[size] || 0, 10) || 0);
            if (q <= 0) return;
            var v = findBagVariant(color, size);
            if (!v) return;
            if (family(color) === 'pink') pink += q;
            else teal += q;
            items.push({
              id: Number(v.id),
              quantity: q,
              price: bagUnitPrice(v, size, bagsPdpSubscribeActive()),
              selling_plan: bagSellingPlanId(v, size, bagsPdpSubscribeActive())
            });
          });
        });
        return { teal: teal, pink: pink, items: items };
      }
      colorCards.forEach(function (card) {
        var name = card.getAttribute('data-color');
        var q = qtyFor(name);
        var id = Number(card.getAttribute('data-variant-id') || 0);
        if (family(name) === 'pink') pink += q;
        else teal += q;
        if (q > 0 && id) items.push({ id: id, quantity: q, price: Number(card.getAttribute('data-price') || 0) });
      });
      return { teal: teal, pink: pink, items: items };
    }

    function colorsWithQty() {
      if (bagsMode) {
        return Object.keys(bagQtyStore).reduce(function (list, key) {
          var bucket = bagQtyStore[key];
          var color = (bucket && bucket.label) || key;
          var qty = Object.keys((bucket && bucket.qtys) || {}).reduce(function (n, size) {
            return n + (Math.max(0, parseInt(bucket.qtys[size] || 0, 10) || 0));
          }, 0);
          if (qty > 0) list.push(color);
          return list;
        }, []);
      }
      return colorCards
        .map(function (card) { return card.getAttribute('data-color'); })
        .filter(function (name) { return qtyFor(name) > 0; });
    }

    function activeColor() {
      var selected = pdp.getAttribute('data-selected-color') || '';
      var withQty = colorsWithQty();
      if (selected && withQty.some(function (name) {
        return colorMatch(name, selected) || name === selected;
      })) {
        return selected;
      }
      return withQty[0] || selected || '';
    }

    function colorCard(name) {
      return colorCards.find(function (el) {
        return colorMatch(el.getAttribute('data-color'), name) || el.getAttribute('data-color') === name;
      }) || null;
    }

    function paintAtcMeta(name, size) {
      if (!metaEl) return;
      var color = name || activeColor();
      if (!color) {
        metaEl.textContent = '';
        return;
      }
      if (bagsMode) {
        var pack = size || currentBagSize();
        metaEl.textContent = pack ? (color + ' • ' + pack + ' ' + bagsWord) : color;
        return;
      }
      metaEl.textContent = inclusion ? color + ' • ' + inclusion : color;
    }

    function focusRemainingColor() {
      var color = activeColor();
      if (!color) return;
      pdp.setAttribute('data-selected-color', color);
      var card = colorCard(color);
      if (card) pdp.setAttribute('data-variant-id', card.getAttribute('data-variant-id') || '');
      rememberPdpColor(color);
      applyPdpTheme();
      syncGallery(color);
      paintAtcMeta(color);
    }

    function applyPdpTheme() {
      var selected = activeColor() || pdp.getAttribute('data-selected-color') || '';
      setTheme(selected || 'teal');
      var q = qtyEntries();
      try {
        localStorage.setItem('snx-teal-qty', String(q.teal || 0));
        localStorage.setItem('snx-pink-qty', String(q.pink || 0));
      } catch (err) {}
    }

    function broadcastVariant(variantId, price, available, name) {
      var detail = {
        productId: pdp.getAttribute('data-product-id') || '',
        variantId: String(variantId || ''),
        price: Number(price) || 0,
        available: available !== false,
        color: name || ''
      };
      document.dispatchEvent(new CustomEvent('swoop:variant-selected', { detail: detail }));
      window.dispatchEvent(new CustomEvent('swoop:variant-selected', { detail: detail }));
    }

    function syncGallery(name) {
      gallerySets.forEach(function (set) {
        var key = (set.getAttribute('data-snx-gallery-set') || '').replace('color:', '');
        var match = colorMatch(key, name) || key.toLowerCase().indexOf(String(name).toLowerCase()) !== -1;
        set.classList.toggle('is-active', match);
        if (match) {
          if (typeof set._snxGoTo === 'function') set._snxGoTo(0);
          else {
            var track = $('[data-snx-gallery-track]', set);
            if (track) track.scrollLeft = 0;
          }
        }
      });
    }

    function updatePromo() {
      var badge = $('[data-snx-promo]', pdp);
      if (!badge || bagsMode) return;
      var total = qtyEntries().items.reduce(function (n, it) { return n + it.quantity; }, 0);
      badge.classList.toggle('is-active', total >= 2);
    }

    function setAtcPrice(value) {
      priceEls.forEach(function (el) {
        el.textContent = value;
      });
    }

    function updateAtcPrice() {
      if (!priceEls.length) return;
      var q = qtyEntries();
      var total = q.items.reduce(function (n, it) { return n + (it.price * it.quantity); }, 0);
      if (!total) total = Number(pdp.getAttribute('data-price') || 0);
      setAtcPrice(money(total));
    }

    function findBagVariant(color, size) {
      var hits = variants.filter(function (v) {
        if (size && String(v.size) !== String(size)) return false;
        if (color && !colorMatch(v.color, color)) return false;
        return true;
      });
      return hits.find(function (v) { return v.available; }) || hits[0] || null;
    }

    function paintBagCards(size) {
      colorCards.forEach(function (card) {
        var v = findBagVariant(card.getAttribute('data-color'), size);
        if (!v) return;
        card.setAttribute('data-variant-id', String(v.id));
        card.setAttribute('data-price', String(bagUnitPrice(v, size, bagsPdpSubscribeActive())));
        card.setAttribute('data-available', v.available ? 'true' : 'false');
        var img = $('img', card);
        if (img && v.image && img.getAttribute('src') !== v.image) {
          img.src = v.image;
          img.removeAttribute('srcset');
        }
      });
    }

    function syncVariantUrl(variantId) {
      if (!variantId || !window.history || !window.history.replaceState) return;
      window.clearTimeout(urlTimer);
      urlTimer = window.setTimeout(function () {
        var url = new URL(window.location.href);
        if (url.searchParams.get('variant') === String(variantId)) return;
        url.searchParams.set('variant', variantId);
        window.history.replaceState({}, '', url);
      }, 120);
    }

    function selectColor(name, variantId, price, available, size) {
      var prevColor = pdp.getAttribute('data-selected-color') || '';
      var prevSize = pdp.getAttribute('data-selected-size') || '';
      var sameColor = colorMatch(prevColor, name) || prevColor === name;
      var sameSize = !size || String(prevSize) === String(size);
      if (sameColor && sameSize && String(pdp.getAttribute('data-variant-id')) === String(variantId)) {
        return;
      }

      pdp.setAttribute('data-selected-color', name);
      if (size) pdp.setAttribute('data-selected-size', size);
      pdp.setAttribute('data-variant-id', variantId);

      if (!bagsMode) {
        if (!sameColor) applyCardClickQty(name);
        else if (qtyFor(name) < 1) setQty(name, 1);
      }
      syncColorSelection();
      if (bagsMode) paintBagQtyUi();
      rememberPdpColor(name);
      if (size && !bagsMode) {
        sizePills.forEach(function (pill) {
          var on = String(pill.getAttribute('data-size')) === String(size);
          pill.classList.toggle('is-selected', on);
          pill.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      }
      paintAtcMeta(name, size);
      setAtcPrice(money(price));
      var sold = pdp.getAttribute('data-sold-out-label') || 'Sold out';
      var add = pdp.getAttribute('data-atc-label') || 'Add to cart';
      btns.forEach(function (el) {
        el.disabled = !available;
        var label = $('[data-snx-atc-label]', el);
        if (label) label.textContent = available ? add : sold;
      });

      applyPdpTheme();
      if (!sameColor) syncGallery(name);
      if (bagsMode) syncBagAtcState();
      else updateAtcPrice();
      updatePromo();
      broadcastVariant(variantId, price, available, name);
      syncVariantUrl(variantId);
    }

    function applyBagSelection(color, size) {
      var prevSize = pdp.getAttribute('data-selected-size') || '';
      if (size && size !== prevSize) paintBagCards(size);
      var v = findBagVariant(color, size);
      if (!v) return;
      selectColor(color, String(v.id), bagUnitPrice(v, size, bagsPdpSubscribeActive()), !!v.available, size);
    }

    colorCards.forEach(function (card) {
      card.addEventListener('click', function () {
        var name = card.getAttribute('data-color');
        if (bagsMode) {
          focusBag(name, currentBagSize());
          return;
        }
        selectColor(
          name,
          card.getAttribute('data-variant-id'),
          Number(card.getAttribute('data-price') || 0),
          card.getAttribute('data-available') === 'true'
        );
      });
    });

    sizePills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var size = pill.getAttribute('data-size') || '';
        if (bagsMode) {
          focusBag(currentBagColor(), size);
          return;
        }
        applyBagSelection(pdp.getAttribute('data-selected-color') || '', size);
      });
    });

    if (bagsMode) {
      refreshBagsPdpOffer = function () {
        paintBagCards(currentBagSize());
        updateAtcPrice();
        syncBagAtcState();
      };
    }

    $$('[data-snx-purchase-mode]', pdp).forEach(function (btn) {
      btn.addEventListener('click', function () {
        setBagsOffer(btn.getAttribute('data-snx-purchase-mode'));
      });
    });

    $$('[data-snx-color-qty-btn]', pdp).forEach(function (qtyBtn) {
      qtyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var pill = qtyBtn.closest('[data-snx-color-qty]');
        var name = pill.getAttribute('data-color');
        var card = colorCards.find(function (el) {
          return colorMatch(el.getAttribute('data-color'), name) || el.getAttribute('data-color') === name;
        });
        if (!card) return;
        if (bagsMode) {
          var size = currentBagSize();
          var next = bagQty(name, size) + Number(qtyBtn.getAttribute('data-snx-color-qty-btn') || 0);
          setBagQty(name, size, next, true);
          if (next > 0) applyBagSelection(name, size);
          else focusRemainingColor();
          paintBagQtyUi();
          syncBagAtcState();
          return;
        }
        var nextColorQty = qtyFor(name) + Number(qtyBtn.getAttribute('data-snx-color-qty-btn') || 0);
        if (nextColorQty < 0) nextColorQty = 0;
        setQty(name, nextColorQty);
        syncColorSelection();
        if (nextColorQty > 0) {
          pdp.setAttribute('data-selected-color', name);
          pdp.setAttribute('data-variant-id', card.getAttribute('data-variant-id'));
          rememberPdpColor(name);
          applyPdpTheme();
          syncGallery(name);
          paintAtcMeta(name);
        } else {
          focusRemainingColor();
        }
        updatePromo();
        updateAtcPrice();
      });
    });

    initGallery(pdp);

    function addFromAtc(trigger) {
      if (!active() || (trigger && trigger.disabled)) return;
      hideBagsError();
      var entries = qtyEntries().items.map(function (it) {
        var line = { id: it.id, quantity: it.quantity };
        if (it.selling_plan) line.selling_plan = it.selling_plan;
        return line;
      });
      if (!entries.length) {
        if (bagsMode) return;
        var fallbackId = Number(pdp.getAttribute('data-variant-id') || 0);
        if (!fallbackId) return;
        entries = [{ id: fallbackId, quantity: 1 }];
      }
      if (bagsMode && bagsPdpSubscribeActive()) {
        var missing = entries.some(function (it) { return !it.selling_plan; });
        if (missing) {
          showBagsError();
          return;
        }
      }
      btns.forEach(function (el) { el.disabled = true; });
      addItem({ items: entries })
        .then(function (res) {
          if (addPayloadFailed(res)) {
            showBagsError(res.description || bagsSubErrorText());
            throw res;
          }
          rememberAdded(res, {
            title: pdp.getAttribute('data-product-title') || '',
            color: pdp.getAttribute('data-selected-color') || storedPdpColor() || '',
            kind: bagsMode ? 'bags' : 'catcher',
            includesBags: bagsMode
          });
          return refreshCart();
        })
        .then(function () { openSheet('upsell'); })
        .catch(function (err) {
          if (addPayloadFailed(err)) return refreshCart();
          return refreshCart().then(function () { openSheet('upsell'); });
        })
        .finally(function () {
          if (bagsMode) syncBagAtcState();
          else btns.forEach(function (el) { el.disabled = false; });
        });
    }

    btns.forEach(function (el) {
      el.addEventListener('click', function () { addFromAtc(el); });
    });

    var footerNear = false;

    function footerTarget() {
      return document.querySelector('.swoop-footer')
        || document.getElementById('footer')
        || document.getElementById('shopify-section-group-footer-group')
        || document.querySelector('footer');
    }

    function updateAtcDock() {
      if (!atc) return;
      var footer = footerTarget();
      if (footer) {
        footerNear = footer.getBoundingClientRect().top < window.innerHeight;
      }
      if (footerNear) {
        atc.classList.remove('is-visible');
        return;
      }
      if (document.body.classList.contains('swoop-landing')) {
        var section = pdp.closest('.shopify-section') || pdp;
        var top = section.getBoundingClientRect().top;
        atc.classList.toggle('is-visible', top <= window.innerHeight - 80);
        return;
      }
      if (!buyBtn || !window.matchMedia('(min-width: 990px)').matches) {
        atc.classList.add('is-visible');
        return;
      }
      var rect = buyBtn.getBoundingClientRect();
      atc.classList.toggle('is-visible', rect.bottom < 88);
    }

    var footerEl = footerTarget();
    if (footerEl && window.IntersectionObserver) {
      var footerIo = new IntersectionObserver(function (entries) {
        footerNear = entries.some(function (entry) { return entry.isIntersecting; });
        updateAtcDock();
      }, { threshold: 0, rootMargin: '80px 0px 0px 0px' });
      footerIo.observe(footerEl);
    }

    window.addEventListener('scroll', updateAtcDock, { passive: true });
    window.addEventListener('resize', updateAtcDock);

    rememberPdpColor(pdp.getAttribute('data-selected-color'));
    if (bagsMode) {
      var initColor = pdp.getAttribute('data-selected-color') || '';
      var initSize = pdp.getAttribute('data-selected-size') || (sizePills[0] && sizePills[0].getAttribute('data-size')) || '';
      if (initColor && initSize) setBagQty(initColor, initSize, 1, false);
      if (initSize) paintBagCards(initSize);
      paintBagQtyUi();
      syncBagAtcState();
    }
    applyPdpTheme();
    updatePromo();
    updateAtcPrice();
    updateAtcDock();
  }

  function initCartUi() {
    var root = $('[data-snx-cart]');
    if (!root) return;

    document.addEventListener('change', function (e) {
      if (!active()) return;
      var sel = e.target.closest('[data-snx-purchase-select]');
      if (!sel || !sel.closest('[data-snx-upsell]')) return;
      var card = sel.closest('[data-snx-upsell-card]');
      if (!card) return;
      setUpsellOfferForSize(card.getAttribute('data-size'), sel.value);
      refreshUpsellCardOffer(card);
      hideBagsError();
    });

    document.addEventListener('click', function (e) {
      if (!active()) return;
      var overlay = e.target.closest('[data-snx-overlay]');
      if (overlay) closeSheets();

      var purchaseBtn = e.target.closest('[data-snx-purchase-mode]');
      if (purchaseBtn && purchaseBtn.closest('[data-snx-upsell]')) {
        setBagsOffer(purchaseBtn.getAttribute('data-snx-purchase-mode'));
        return;
      }

      var add = e.target.closest('[data-snx-upsell-add], [data-snx-empty-add]');
      if (add) {
        var vid = Number(add.getAttribute('data-variant-id') || 0);
        if (!vid) return;
        var line = { id: vid, quantity: 1 };
        var card = add.closest('[data-snx-upsell-card]');
        var isBagsAdd = false;
        if (add.hasAttribute('data-snx-empty-add')) {
          var bagsId = Number((root && root.getAttribute('data-bags-id')) || 0);
          isBagsAdd = !!(bagsId && String(add.getAttribute('data-product-id')) === String(bagsId));
        } else {
          isBagsAdd = !!(card && packSizeKey(card.getAttribute('data-size')));
        }
        if (isBagsAdd) {
          var subscribe = card ? upsellCardSubscribe(card) : bagsCartSubscribeActive();
          if (subscribe) {
            var planId = Number(add.getAttribute('data-selling-plan') || 0);
            if (!planId) {
              var offer = bagOfferByVariantId(vid);
              planId = bagSellingPlanId(offer || { id: vid, selling_plans: (offer && offer.selling_plans) || [] }, offer && offer.size, true);
            }
            if (!planId) {
              showBagsError();
              return;
            }
            line.selling_plan = planId;
          }
        }
        add.disabled = true;
        hideBagsError();
        var offerType = card ? (card.getAttribute('data-offer-type') || '') : '';
        var fromUpsell = !!(card && card.closest('[data-snx-upsell]'));
        addItem({ items: [line] })
          .then(function (res) {
            if (addPayloadFailed(res)) throw res;
            rememberAdded(res, {
              kind: offerType,
              color: card ? (card.getAttribute('data-offer-color') || '') : '',
              includesBags: offerType === 'bags',
              fromUpsell: fromUpsell
            });
            return refreshCart();
          })
          .catch(refreshCart)
          .finally(function () { add.disabled = false; });
        return;
      }

      var qtyBtn = e.target.closest('[data-snx-qty]');
      if (qtyBtn) {
        var item = qtyBtn.closest('[data-snx-item]');
        if (!item || !cartState) return;
        var key = item.getAttribute('data-key');
        var line = (cartState.items || []).find(function (it) { return it.key === key; });
        if (!line) return;
        var nextQty = line.quantity + Number(qtyBtn.getAttribute('data-snx-qty') || 0);
        changeItem(key, Math.max(0, nextQty)).then(paintCart).catch(refreshCart);
        return;
      }

      var remove = e.target.closest('[data-snx-remove]');
      if (remove) {
        var row = remove.closest('[data-snx-item]');
        if (!row) return;
        changeItem(row.getAttribute('data-key'), 0).then(paintCart).catch(refreshCart);
        return;
      }

      if (e.target.closest('[data-snx-checkout]')) {
        window.location.href = checkoutUrl();
      }
    });

    refreshCart();
  }

  function initExternalCartHooks() {
    if (window.__snxExternalCart) return;
    window.__snxExternalCart = true;
    document.addEventListener('snx:cart-added', function (e) {
      if (!kitIsNext()) return;
      var d = (e && e.detail) || {};
      rememberAdded(d.response, {
        title: d.title || '',
        color: d.color || '',
        kind: d.kind || '',
        includesBags: !!d.includesBags
      });
      refreshCart().then(function () {
        openSheet(d.sheet || 'upsell');
      });
    });
  }

  function formatShipDay(date) {
    var pdp = $('[data-snx-pdp]');
    var locale = (pdp && pdp.getAttribute('data-date-locale')) || document.documentElement.lang || 'en';
    try {
      return date.toLocaleDateString(locale, { month: 'short', day: 'numeric' });
    } catch (err) {
      return date.toLocaleDateString('en', { month: 'short', day: 'numeric' });
    }
  }

  function initShipDate() {
    var label = formatShipDay(new Date());
    $$('[data-snx-ship-tpl]').forEach(function (el) {
      var tpl = el.getAttribute('data-snx-ship-tpl') || '';
      if (tpl.indexOf('{date}') === -1) tpl += ', {date}';
      el.textContent = tpl.split('{date}').join(label);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (!kitIsNext()) return;
    try { applyThemeFromCart(null); } catch (err) {}
    try { initHeaderChrome(); } catch (err) {}
    try { initNav(); } catch (err) {}
    try { initPdp(); } catch (err) {}
    try { initCartUi(); } catch (err) {}
    try { initExternalCartHooks(); } catch (err) {}
    try { initShipDate(); } catch (err) {}
  });
})();
